import {HttpRequest,HttpMethod} from "./http";

class PaymentMethodProvider extends HttpRequest {

	// CRUD Product	
	PaymentMethodCreate(params) {
		return this.request(HttpMethod.Post,`/api/v1/paymentmethod`,params );
	}

	PaymentMethodList(params) {
		return this.request(HttpMethod.Get,`/api/v1/paymentmethod`,params );
	}

	PaymentMethodUpdate(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/paymentmethod/${id}`,params );
	}

	PaymentMethodDelete(id) {
		return this.request(HttpMethod.Delete,`/api/v1/paymentmethod/${id}`);
	}


}

export default PaymentMethodProvider